export const testimonials = [
  {
    id: "dep-1",
    text: "Tá top a pele! Lisinha, sabe? E sensação de limpeza mesmo, amei! Vi muita diferença até na hora de passar a maquiagem.",
    service: "Limpeza de Pele",
  },
  {
    id: "dep-2",
    text: "Estou muito satisfeita com o resultado. Só de olhar no espelho e não ver aqueles pontinhos pretinhos já é um alívio enorme.",
    service: "Limpeza de Pele",
  },
  {
    id: "dep-3",
    text: "Ficou simplesmente impecável o trabalho! Ficou foda o resultado, Jennifer. Curti pra caralho! Obrigada por cuidar tão bem de mim.",
    service: "Design de Sobrancelhas",
  },
  {
    id: "dep-4",
    text: "Atendimento impecável e resultado maravilhoso! Fiz minhas sobrancelhas e amei o cuidado em cada detalhe. O espaço é lindo, aconchegante e o trabalho é feito com muito capricho. Super recomendo!",
    service: "Design de Sobrancelhas",
  },
  {
    id: "dep-5",
    text: "Atendimento nota mil, a Jennifer é maravilhosa, atenciosa, faz seu trabalho com amor e o resultado é impecável sempre! Não troco por nenhuma outra.",
    service: "",
  },
  {
    id: "dep-6",
    text: "Studio muito completo, a Jennifer é uma ótima profissional, atendeu muito bem e sempre com muito profissionalismo.",
    service: "",
  },
  {
    id: "dep-7",
    text: "Excelente profissional, muito cuidado em todos os atendimentos!! Indico de olhos fechados.",
    service: "",
  },
  {
    id: "dep-8",
    text: "Espaço lindo e aconchegante, trabalho impecável, todos procedimentos muito bem feitos com uma mão leve e delicada, sempre faço minhas sobrancelhas com a Jennifer, adoro seu trabalho.",
    service: "Design de Sobrancelhas",
  },
];